module.exports = __webpack_public_path__ + "media/images/redesign-images/misc/nav-image-05-9e5a6fb1541d0e29f51c597205e95e89.webp";